import {
  DropDownProps,
  Dropdown as DropdownBase,
  DropdownBodyAlignment,
  ModalDialog,
  ModalDialogBodyContent,
  ModalDialogCloseButton,
  ModalDialogContent,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {ReactNode} from 'react';
import {
  MiniArticleDetailsLayout,
  MiniArticleDetailsLayoutProps,
} from '../MiniArticleDetailsLayout/MiniArticleDetailsLayout';

interface MiniADPDialogProps extends MiniArticleDetailsLayoutProps {
  children?: ReactNode;
  onClose?: VoidFunction;
  closeButton?: ReactNode;
  isOpen: boolean;
  isQuickView?: boolean;
  skipAnimation?: boolean;
  onUnmount?: VoidFunction;
  renderInPortal?: boolean;
}

export const MiniADPDialog = ({
  children,
  onClose = () => null,
  isOpen,
  isQuickView,
  closeButton,
  skipAnimation,
  onUnmount,
  renderInPortal,
  ...rest
}: MiniADPDialogProps) => {
  return (
    <StyledModalDialog
      preventAnimation={skipAnimation}
      onUnmount={onUnmount}
      contentFitWidth
      fixedSmallWidth={false}
      open={isOpen}
      onClose={onClose}
      data-testid="MiniADPDialog"
      backgroundBlur={isQuickView}
      renderInPortal={renderInPortal}
      bodyContent={
        <>
          {children}
          <Content data-testid="QuickViewWrapperRendered">
            <DetailsWrapper data-testid="MiniADPQuickViewContent">
              {closeButton ?? (
                <StyledModalDialogCloseButton
                  data-testid="MiniADPDialogClose"
                  onClick={onClose}
                />
              )}
              <MiniArticleDetailsLayout {...rest} />
            </DetailsWrapper>
          </Content>
        </>
      }
    />
  );
};

const StyledModalDialog = styled(ModalDialog)`
  && ${ModalDialogContent} {
    max-width: 800px;
    padding: 0;
    overflow-x: hidden;
  }

  && ${ModalDialogBodyContent} {
    padding: 0;

    & > * {
      font-size: unset;
      line-height: unset;
    }
  }

  && ${ModalDialogBodyContent} ${ModalDialogBodyContent} {
    padding: unset;
  }
`;

const StyledModalDialogCloseButton = styled(ModalDialogCloseButton)`
  position: absolute;
  right: 0;
  top: 0;

  &&& {
    padding: 24px;
  }
`;

const DetailsWrapper = styled.div`
  padding: 1rem 1rem;
  padding-right: 40px;
  position: relative;
`;

const Content = styled.div`
  max-width: 750px;
  width: 100vw;
`;

const StyledDropdown = styled(DropdownBase)`
  display: flow-root;
  width: 100%;

  & [data-center-dropdown-content='true'] {
    // subtract half the gap size between buy box and product image + add gap size of 40px (to align size and image)
    min-width: calc(50% - 1.25rem + 40px);
    max-width: calc(50% - 1.25rem + 40px);
    overflow: hidden;
    width: unset;
  }
`;

export const MiniADPDropdown: React.FC<DropDownProps> = props => {
  return (
    <StyledDropdown
      {...props}
      dropdownBodyWidth="100%"
      animationDuration={300}
      dropdownBodyAlign={DropdownBodyAlignment.RIGHT}
      isActive
    />
  );
};
